import { Avatar, ConfigProvider, Dropdown, Empty, Menu, message, Pagination } from "antd";
import Search from "antd/lib/input/Search";
import React, { Component } from "react";
import { FcManager } from "react-icons/fc";
import { IoLogOutOutline, IoPersonOutline } from "react-icons/io5";
import { logout } from "../configOidc";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import { GetCAOrgAssosiaction, SaveCAOrgAssosiaction } from "../_services/CommonService";

class CALayoutPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            UserName: JSON.parse(localStorage.getItem("userDetails")).CaSignUpEmail,
            CAOrgList: [],
            CAOrgData: [],
            searchText: "",
            currentPage: 1,
            pageSize: 20
        };
        this.usermenu = (
            <Menu style={{ minWidth: "150px" }} items={[
                {
                    label: (
                        <a rel="noopener noreferrer" disabled className="ClientInfo">
                            <IoPersonOutline style={{ fontSize: 16, marginRight: "6px" }} />
                            <span>{this.state.UserName ? this.state.UserName : ""}</span>
                        </a>
                    )
                },
                {
                    label: (
                        <a rel="noopener noreferrer" onClick={this.logoutUser}>
                            <IoLogOutOutline style={{ fontSize: 16, marginRight: "6px" }} />
                            Logout
                        </a>
                    )
                }]} >
            </Menu>
        );
    }

    componentDidMount = () => {
        this.GetCAOrgAssosiationList()
        if (window.location.pathname === "/PartnerLayoutPage") {
            let userkeys = ["userDetails", "UserName", "CAUserName", "UserType"]
            Object.keys(localStorage).forEach(x => {
                if (!userkeys.includes(x)) {
                    localStorage.removeItem(x);
                }
            });
        }
    }

    logoutUser = (e) => {
        e.preventDefault()
        logout()
    }

    changeColorTheme = (color) => {
        ConfigProvider.config({
            theme: {
                primaryColor: "#5673e5", //color,
            }
        });
    }

    handleCardClick = (item) => {
        localStorage.setItem("OrgCode", item.orgCode)
        localStorage.setItem("UserName", item.orgEmail)
        localStorage.setItem("UserType",item.partnerType)
        localStorage.setItem('CountryCode', item.countryCode);
        if(item.countryCode === 'AE'){
            localStorage.setItem("isUAElogin","true")
        }else{
            localStorage.setItem("isUAElogin","false")
        }
        window.location.pathname = '/layout'
    };

    GetCAOrgAssosiationList = async () => {
        let OrgSub = JSON.parse(localStorage.getItem("userDetails"))
        await GetCAOrgAssosiaction(OrgSub.sub).then((res) => {
            if (res.data.success) {
                if (res.data.data.length > 0) {
                    this.setState({ CAOrgList: res.data.data, CAOrgData: res.data.data })
                }
                else {
                    <img src="/path/to/no-data-icon.svg" alt="No Data" class="no-data-icon" />
                }
            }
            else {
                message.destroy();
                message.error(res.data.message);
            }
        })
    }


    handleSearch = (value) => {
        if (!value) {
            this.setState({ CAOrgList: this.state.CAOrgData, searchText: "" });
            return;
        }
        const filtered = this.state.CAOrgData.filter(item =>
            item.orgName.toLowerCase().includes(value.toLowerCase()) ||
            item.orgEmail.toLowerCase().includes(value.toLowerCase())
        );
        this.setState({ CAOrgList: filtered, searchText: value });
    }

    handlePageChange = (page, pageSize) => {
        this.setState({ currentPage: page, pageSize });
    };
    render() {
        const { CAOrgList, currentPage, pageSize } = this.state;
        const startIndex = (currentPage - 1) * pageSize;
        const paginatedList = CAOrgList.slice(startIndex, startIndex + pageSize);
        return (
            <div style={{ paddingBottom: "20px", background: "white" }}>
                <div
                    className="headerContainer"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "10px 20px",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        backgroundColor: "#fff",
                        zIndex: 1000,
                        position: "relative",
                    }}>
                    <span >
                        <img src="/images/uBooks_360.jpg" alt="Logo" className="ublogo" style={{ height: "40px" }} />
                    </span>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "20px",
                        }}
                    >
                        <Search
                            placeholder="search here"
                            style={{ width: "300px" }}
                            value={this.state.searchText}
                            onChange={(e) => this.setState({ searchText: e.target.value })}
                            onSearch={this.handleSearch}
                            enterButton
                        />

                        <section className="avatarUserSection">
                            <Dropdown overlay={this.usermenu} placement="bottom">
                                <a
                                    href="/"
                                    className="ant-dropdown-link"
                                    onClick={(e) => e.preventDefault()}
                                >
                                    <Avatar
                                        size={40}
                                        style={{ lineHeight: "24px" }}
                                        icon={<FcManager style={{ fontSize: "39px", marginTop: "3px" }} />}
                                    />
                                </a>
                            </Dropdown>
                        </section>
                    </div>
                </div>

                <div style={{ padding: '30px 30px', }}>
                    {CAOrgList.length === 0 ? (
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<b>No Data</b>}  />
                    ) : (
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
                            {paginatedList.map((item) => (
                                <div key={item.id}
                                    style={{
                                        width: "300px", height: "70px", display: "flex", alignItems: "center", gap: "15px",
                                        backgroundImage: "url('../configbg2.svg')", backgroundPosition: 'center 120px', borderRadius: "1px", padding: "15px", boxShadow: "0 3px 5px -3px #b7b7b7", transition: "all 0.3s ease",cursor:"pointer"
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.boxShadow = '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)';
                                        e.currentTarget.style.transform = "scale(1.05)";

                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow = "0 3px 5px -3px #b7b7b7";
                                        e.currentTarget.style.transform = "translateY(0)";
                                    }}
                                    onClick={(e) => { this.handleCardClick(item) }}
                                >
                                    <img src={item.logo ? `data:image/*;base64,${item.logo}` : "/images/no_preview.png"} alt={item.orgName} style={{ width: "50px", height: "50px", borderRadius: "8px" }} />
                                    <div>
                                        <h3 style={{ margin: "0 0 5px 0", fontSize: "14px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "200px" }} title={item.orgName} >{item.orgName}</h3>
                                        <p style={{ margin: "0", fontSize: "12px", color: "#555" }}> {item.orgEmail}</p>
                                        <p style={{ margin: "0", fontSize: "12px", color: "#777" }}>{item.phoneNo}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div style={{ marginTop: 20, textAlign: "right", marginRight: 20 }}>
                    {CAOrgList.length > 0 && <Pagination
                        current={currentPage}
                        pageSize={pageSize}
                        total={CAOrgList.length}
                        onChange={this.handlePageChange}
                    />}
                </div>
            </div>
        );
    }
}

export default CALayoutPage;
